import React, { useState, useEffect } from "react";
import AssetRequest from "./AssetRequest";
import AccessRequest from "./AccessRequest";
import Breadcrumbs from "../../components/Breadcrumbs";
import { Link } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
export const AssetRequestTabs = ({ title }) => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [searchParams] = useSearchParams();
  const tabs = [
    { label: "Asset Request", component: AssetRequest },
    { label: "Access Request", component: AccessRequest },
  ];

  console.log("title: ", title);

  useEffect(() => {
    const tabParam = searchParams.get("tab");
    if (tabParam === "access") {
      setActiveTabIndex(1); // Open Access Request tab
    } else if (tabParam === "asset") {
      setActiveTabIndex(0); // Open Asset Request tab
    }
  }, [searchParams]);

  return (
    <>
      <div className="wrapper-body">
        <div className="page-heading">
          <Breadcrumbs
            items={[
              {
                label: "IT Resource Requests",
                path: "/dashboard/assetRequest",
              },
              { label: tabs[activeTabIndex].label },
            ]}
            className="projectListBackButton"
          />
          <Link
            to={`/dashboard/assetRequest?tab=${
              activeTabIndex === 0 ? "asset" : "access"
            }`}
            className="brand-color"
          >
            <button
              type="button"
              className="theme-button ms-3 px-4 bg-red back-button"
            >
              Back
            </button>
          </Link>
        </div>

        <div className="card ">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <ul className="nav nav-tabs" role="tablist">
              {tabs.map((item, index) => (
                <li className="nav-item" role="presentation" key={index}>
                  <button
                    className={`nav-link ${
                      activeTabIndex === index ? "active" : ""
                    }`}
                    type="button"
                    role="tab"
                    aria-selected={activeTabIndex === index}
                    onClick={() => setActiveTabIndex(index)}
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="tab-content mt-3 px-3">
            {tabs.map((item, index) => {
              const Component = item.component;
              return (
                activeTabIndex === index && (
                  <div
                    key={index}
                    className="tab-pane fade show active"
                    role="tabpanel"
                  >
                    <Component title={item.label} description={""} />
                  </div>
                )
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default AssetRequestTabs;
